import { store } from '@core/Store'
import { setMeetingsRaceCode } from '@core/Areas/Meetings/Store'
import { QUICKBET_MODAL_ID } from '@core/Areas/Quickbet/constants'
import { closeModal } from '@core/Components/Modal'
import { AppRoutes } from '@core/AppRoutes'
import { state$ as navState$ } from '@core/State/Navigation/driver'
import { appHistory } from '@core/Utils/routing/history'

export const navigateToLastRacesPath = () => {
  navState$.take(1).subscribe(navState => {
    store.dispatch(closeModal({ id: QUICKBET_MODAL_ID }))

    const lastRacesPath = navState.get('lastRacesPath')
    const currentHashPath = navState.get('currentUrl')

    const newRacesPath = currentHashPath === lastRacesPath ? AppRoutes.Meetings : lastRacesPath

    if (currentHashPath.split('?')[0] === AppRoutes.Meetings) {
      store.dispatch(setMeetingsRaceCode('races'))
    }

    appHistory.push(newRacesPath)
  })
}
